
export default {

  SET_STUDENT(state, payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser
      if (payload != null) {
        // Update key in localStorage
        userInfo['listStudents'] = payload
      }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },

  SELECT_STUDENT(state, payload) {
    let selectedStudent;

    if(localStorage.getItem("student") == null){
      localStorage.setItem("student",JSON.stringify(payload));
    }else{
      if(payload == null){
        selectedStudent = localStorage.removeItem("student");
      }else{
        localStorage.setItem("student",JSON.stringify(payload));
      }
    }
  },
  INSERT_UPDATE_STUDENT(state, payload) {
    if(localStorage.getItem("student") != null){
      localStorage.setItem("student",JSON.stringify(payload));
    }
  },
}
